import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; 
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import chatReducer from "./chatSlice";
import planReducer from "./planSlice";
import usageReducer from "./usageSlice";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist/es/constants";

// Persist configurations
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["chat", "plans", "usage"], // Persist these reducers
};

// Combine reducers
const rootReducer = combineReducers({
  chat: chatReducer,
  plans: planReducer,
  usage: usageReducer,
});

// Apply persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with ignored actions
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
